// Shim that replaces SvelteKit's $app/stores `page` store.
//
// In SvelteKit, `page` exposes the current `url`, `params`, `route`, etc.
// In a plain Svelte SPA we synthesise an equivalent that updates whenever
// the browser URL changes (popstate, pushState, replaceState).

import { writable } from 'svelte/store';

function snapshot() {
  if (typeof window === 'undefined') {
    return {
      url: new URL('http://localhost/'),
      params: {},
      route: { id: null },
      status: 200,
      error: null,
      form: null,
      data: {}
    };
  }
  return {
    url: new URL(window.location.href),
    params: {},
    route: { id: window.location.pathname },
    status: 200,
    error: null,
    form: null,
    data: {}
  };
}

export const page = writable(snapshot());

if (typeof window !== 'undefined') {
  // Native back/forward.
  window.addEventListener('popstate', () => page.set(snapshot()));

  // Intercept pushState / replaceState so programmatic navigation also
  // triggers store updates. svelte-routing's `navigate` ultimately calls
  // these, so this catches both vendor-router and direct History API use.
  const wrap = (name) => {
    const original = window.history[name];
    window.history[name] = function (...args) {
      const result = original.apply(this, args);
      page.set(snapshot());
      return result;
    };
  };
  wrap('pushState');
  wrap('replaceState');
}
